<template>
  <div class="flex -mx-3">
    <div class="w-48 px-3">
      <RouterLink :to="{ name: 'admin.roles.show', params: { roleId: role.id } }">
        {{ role.name | capitalize }}
      </RouterLink>
    </div>
    <div class="flex-1 px-3">
      {{ role.description }}
    </div>
    <div class="w-48 px-3">
      <span class="inline-block bg-teal-500 rounded text-teal-100 px-3 py-1 leading-normal">
        {{ role.guardName }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratItem',
  props: {
    role: {
      type: Object,
      required: true,
    },
  },
};
</script>
